// const oldApp = process.env.OLD_APP_URL
const links = [
  {
    tag: "How it works",
    url: `/how-it-works`,
    otherApp: false
  },
  {
    tag: "For business",
    url: `/business`,
    otherApp: false
  },
  {
    tag: "FAQ",
    url: `/faq`,
    otherApp: false
  },
  {
    tag: "Blog",
    url: "https://blog.appwinit.com",
    otherApp: true
  }
]

export default links
